import React from "react";
import {
  Button, Col, Result, Row,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { StoreLayout } from "components/store-layout/StoreLayout";

import "./StoreNotFound.less";

export function StoreNotFound() {
  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <StoreLayout>
      <Row
        className="store-not-found__content"
        justify="space-around"
        align="middle"
      >
        <Col>
          <Result
            status="404"
            title="404"
            subTitle={<strong>{intl.formatMessage({ id: "jmix-store.not-found.sub-title" })}</strong>}
            extra={(
              <Button
                type="primary"
                onClick={() => navigate("/")}
              >
                {intl.formatMessage({ id: "jmix-store.not-found.back-home" })}
              </Button>
            )}
          />
        </Col>
      </Row>
    </StoreLayout>
  );
}
